import React, { useEffect, useState } from 'react'
import { queryView } from "../../../Context/api";
import axios from "axios";
import { commonMessage, statusCodes } from "../../../Constants/generalConfig";
import Spinner from '../../Spinner/spinner';
import { ToastContainer, toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useFormik } from 'formik';

const View = () => {
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams()

    useEffect(() => {
        list()
    }, [])
    const list = () => {
        setSpinner(true)
        axios.post(queryView(), { _id: id }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                planView.setValues(resp.data.data[0])
                setSpinner(false)
            }
            else {
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })

    };
    const planView = useFormik({
        initialValues: {
            name: '',
            providerName: '',
            email: '',
            mobileNo: '',
            queryType: '',
            description: '',
            planOption: ''
        },
        onSubmit: () => {

        }
    })
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Custom Plan
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4">

                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                disabled
                                onChange={planView.handleChange}
                                value={planView.values.name}
                            />
                        </div>
                        {/* <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Business Name</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='providerName'
                                disabled
                                onChange={planView.handleChange}
                                value={planView.values.providerName}
                            />
                        </div> */}
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Email</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='email'
                                disabled
                                onChange={planView.handleChange}
                                value={planView.values.email}
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Mobile Number</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='mobileNo'
                                disabled
                                onChange={planView.handleChange}
                                value={planView.values.mobileNo}
                            />
                        </div>
                        {/* <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Query Type</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='queryType'
                                disabled
                                onChange={planView.handleChange}
                                value={planView.values.queryType}
                            />
                        </div> */}
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Description</label>
                            <textarea className='form-control' cols="30" rows="1" name='description' disabled onChange={planView.handleChange} value={planView.values.description}></textarea>
                        </div>
                        {/* <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Plan Option</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='planOption'
                                disabled
                                onChange={planView.handleChange}
                                value={planView.values.planOption}
                            />
                        </div> */}
                        {/* <div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div> */}
                    </form>
                </div>
            </section>
        </>
    )
}

export default View